(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.artist_grid_formatter_v1 = {
    attach: function (context) {
      var $pagedArtistTile = $('.artistry-artist--paged', context); // there are many on the all artists page
      var $artistPager = $('.js-artists-pager', context); // pager link

      $artistPager.on('click', function (e) {
        e.preventDefault();
        $('.artistry-artist--paged:hidden').fadeIn('500').addClass('paged-show').matchHeight('remove');
        // Reapply matchHeight to ensure correct heights due to grid collapse
        $.fn.matchHeight._apply('.artistry-artist--paged');
        if ($('.artistry-artist--paged:hidden').length === 0) { // check if any hidden artists still exist
          $artistPager.hide();
        }
      });
    } // attach
  };
})(jQuery, Drupal);
